// src/apiConfig.js
const API_BASE_URL = process.env.VUE_APP_API_URL;

export const API_ENDPOINTS = {
    // Employee APIs
    fetchAllEmployees: `${API_BASE_URL}/view-employees/employees-data-short/{employeeId}/{companyId}/{archiveStatus}`,

    // Dashboard
    fetchUpcomingRoster: `${API_BASE_URL}/view-roster/dashboard-roster`,
    fetchUpcomingEmployees: `${API_BASE_URL}/view-roster/dashboard-attendance/{startDate}/{endDate}`,
    fetchNotlogoutEmployees: `${API_BASE_URL}/view-roster/dashboard-not-logout`,
    fetchOnlineEmployees: `${API_BASE_URL}/view-attendance/online-status`,

    // KIOSK
    clockIn: `${API_BASE_URL}/mark/kiosk/clockin`,
    clockOut: `${API_BASE_URL}/mark/kiosk/clockout`,
    fetchKioskNotLogoutById:  `${API_BASE_URL}/view-roster/kiosk-not-logout/{employeeId}/{shiftName}`,
    fetchKioskRosterById:  `${API_BASE_URL}/view-roster/kiosk-roster/{employeeId}/{shiftName}`
}